export enum RegionEnum {
    norte = 1,
    nordeste = 2,
    centroOeste = 3,
    sudeste  = 4,
    sul = 5
}
